import React from 'react';
import { Navigation } from '../../../services/NavigationService';
import {ReactComponent as BackArrow} from '../../../assets/back-arrow.svg';


function BackButton({path, search,reload}) {
    const handleClick = () => {
        Navigation.push({pathname:path, search:search});
        if(reload===true){
            window.location.reload(true);
        }

    }
    return (
        <BackArrow style={{cursor:'pointer'}}onClick={handleClick}/>
    )
}

export default BackButton
